import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { Icon, IconButton } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import Notification from "./components/notification"
import "./custom.css"
import Slider from "react-slick"
import { useRef } from "react"
import helloIcon from "assets/images/apollo-english/hello.svg"
import {
  useMaterialUIController,
  setOpenNotification,
  setMiniSidenav,
} from "context"
import { NotificationTab } from "./components/NotificationTab"
import { selectAuth } from "shared/redux/slices/authSlice"
import { useSelector } from "react-redux"
import companyTripHomeBanner from "assets/images/apollo-english/company-trip-home-banner.jpg"
import appBannerHome from "assets/images/apollo-english/app-banner-home.jpg"
import useImageWithFallback from "shared/hooks/useImageWithFallback"

const COMPANY_TRIP_URL =
  "https://apollo.edu.vn/company-trip-2026?zarsrc=31&utm_source=zalo&utm_medium=zalo&utm_campaign=zalo"

const FALLBACK_IMG_URL =
  "https://crmlearn.sgp1.digitaloceanspaces.com/images/Cover_HomepageBannerMyApollo2.jpg"

const HOME_BANNERS = [
  {
    imgUrl: companyTripHomeBanner,
    linkUrl: COMPANY_TRIP_URL,
  },
  {
    imgUrl: appBannerHome,
    linkUrl: "",
  },
]

// One slide — its own component so useImageWithFallback (a hook) can run
// per item instead of inside the .map() below.
const HeaderSlide = ({ item }) => {
  const imgUrl = useImageWithFallback(item.imgUrl, FALLBACK_IMG_URL)
  return (
    <MDBox
      sx={{
        height: "100%",
        width: "100%",
        display: "block",
        cursor: "pointer",
      }}
      onClick={() => {
        if (item.linkUrl) {
          window.open(item.linkUrl, "_blank")
        }
      }}
    >
      <MDBox
        sx={{
          height: "100%",
          backgroundImage: `url("${imgUrl}")`,
          backgroundSize: "cover",
          backgroundPosition: "inherit",
        }}
      ></MDBox>
    </MDBox>
  )
}

function Header() {
  const sliderRef = useRef(null)

  const [controller, dispatch] = useMaterialUIController()

  const { openNotification, miniSidenav, darkMode, transparentNavbar } =
    controller

  const handleNotificationOpen = (e) => {
    setOpenNotification(dispatch, !openNotification)
  }

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav)

  const theme = useTheme()
  const xlMatches = useMediaQuery(theme.breakpoints.up("xl"))

  const settings = {
    customPaging: function () {
      return <div className="custom-dot"></div>
    },
    dots: xlMatches && HOME_BANNERS.length > 1,
    infinite: HOME_BANNERS.length > 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const auth = useSelector(selectAuth)

  return (
    <MDBox
      sx={({ functions: { pxToRem } }) => ({
        width: "100%",
        height: pxToRem(290),
        position: "relative",
        overflow: "hidden",
      })}
      id="header"
    >
      <Slider ref={sliderRef} {...settings}>
        {HOME_BANNERS.map((item, index) => (
          <HeaderSlide key={index} item={item} />
        ))}
      </Slider>

      <IconButton
        sx={({ breakpoints }) => ({
          display: "none !important",
          cursor: "pointer",
          position: "absolute",
          top: 20,
          left: 20,

          [breakpoints.up("xl")]: {
            display: "inline-block !important",
          },

          [breakpoints.down("xl")]: {
            display: "inline-block !important",
          },
        })}
        onClick={handleMiniSidenav}
        size="small"
        disableRipple
      >
        <Icon
          fontSize="medium"
          sx={({ palette: { dark, white, text }, functions: { rgba } }) => ({
            color: () => {
              let colorValue = darkMode ? white.main : dark.main

              if (transparentNavbar) {
                colorValue = darkMode ? rgba(text.main, 0.6) : text.main
              }

              return colorValue
            },
          })}
        >
          {miniSidenav ? "menu_open" : "menu"}
        </Icon>
      </IconButton>
      {/* <MDBox
        sx={(theme) => ArrowStyles(theme, { miniSidenav, type: "left" })}
        onClick={() => sliderRef?.current?.slickPrev()}
      >
        <Icon component={() => <HeaderPrevArrow />} />
      </MDBox>
      <MDBox
        sx={(theme) => ArrowStyles(theme, { miniSidenav, type: "right" })}
        onClick={() => sliderRef?.current?.slickNext()}
      >
        <Icon component={() => <HeaderNextArrow />} />
      </MDBox> */}

      <NotificationTab handleNotificationOpen={handleNotificationOpen} />

      <MDBox
        sx={({ breakpoints, functions: { pxToRem } }) => ({
          position: "absolute",
          top: pxToRem(190),
          left: pxToRem(80),

          [breakpoints.down("xl")]: {
            left: pxToRem(64),
          },

          [breakpoints.down("lg")]: {
            left: pxToRem(48),
          },

          [breakpoints.down("md")]: {
            left: pxToRem(24),
          },
        })}
      >
        <MDTypography
          variant="h1"
          sx={({ palette, typography }) => ({
            color: palette.white.main,
            fontFamily: typography.lexendFont,
            fontSize: 30,
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "137%",
            letterSpacing: "-0.8px",
            textShadow: "-1px 1px 8px #000000",
          })}
        >
          Hi {auth.user.fullName}
          <MDBox
            component="img"
            src={helloIcon}
            width="2rem"
            sx={({ functions: { pxToRem } }) => ({
              width: pxToRem(32),
              height: pxToRem(32),
              display: "inline-block",
              marginLeft: "1rem",
            })}
          ></MDBox>
        </MDTypography>

        <MDTypography
          variant="p"
          sx={({ typography }) => ({
            color: "rgb(21, 118, 188)",
            fontFamily: typography.lexendFont,
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "162.5%",
            letterSpacing: "-0.8px",
          })}
        >
          Welcome to My Apollo
        </MDTypography>
      </MDBox>

      <Notification />
    </MDBox>
  )
}

export default Header
